import { useEffect, useState } from "react";
import { Landmark } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { PortalOrdersPanel } from "./PortalOrdersPanel";

export function PortalOrdersButton({ onChanged, autoOpen = false }) {
  const [open, setOpen] = useState(autoOpen);
  const [count, setCount] = useState(0);
  useEffect(() => { api.get("/portal-orders", { params: { status: "menunggu" } }).then((r) => setCount(r.data.length)).catch(() => {}); }, []);
  return (
    <>
      <Button variant="outline" className="text-sky-400 border-sky-500/40 hover:bg-sky-500/10 relative" onClick={() => setOpen(true)} data-testid="btn-portal-orders">
        <Landmark className="w-4 h-4 mr-2" /> Tagihan Portal (Transfer BCA)
        {count > 0 && <span className="ml-2 min-w-5 h-5 px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold font-mono flex items-center justify-center" data-testid="portal-orders-badge">{count}</span>}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-5xl max-h-[85vh] overflow-y-auto" data-testid="portal-orders-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Landmark className="w-5 h-5 text-sky-400" /> Tagihan Portal — Transfer BCA 029 990 4000</DialogTitle>
            <DialogDescription>Cocokkan nominal transfer masuk (3 angka terakhir = kode unik) dengan mutasi bank, lalu <b>Konfirmasi</b>. Sistem memperpanjang 30 hari, mengaktifkan secret, mencatat transaksi PPPoE, dan membagi komisi agen cabang otomatis.</DialogDescription>
          </DialogHeader>
          <PortalOrdersPanel active={open} onChanged={() => { onChanged?.(); api.get("/portal-orders", { params: { status: "menunggu" } }).then((r) => setCount(r.data.length)).catch(() => {}); }} onRows={(r, st) => { if (st === "menunggu") setCount(r.length); }} />
        </DialogContent>
      </Dialog>
    </>
  );
}
